export const URL_BASE = 'https://vue-flix-backend.herokuapp.com/'
export const NAME_TOKEN = 'auth_token'
export const PREFX_STORAGE = 'vueflix'
export const API_TOKEN = '668c7a3f4c06597eb4ec7315cfaa1f47'
export const IMG_SIZE_185 = 'https://image.tmdb.org/t/p/w185'
export const IMG_SIZE_1280 = 'https://image.tmdb.org/t/p/w1280'



// WEBPACK FOOTER //
// ./src/configs/configs.js